import { ICourseRateDetails, IRateCourseData } from "../../models/student/studentCourceDetail";
import { IApiResponse } from "../../models/IAPIResponse";
import { student } from "../../constants/apiUrl";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";

export default new (class RateCourseService {
  public createStudentCourseRate = async (
    data: IRateCourseData
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = student.STUDENT_RATE_COURSE;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public getStudentCourseRate = async (
    courseId: number
  ): Promise<IApiResponse<ICourseRateDetails>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_RATE_COURSE_DETAILS, [`${courseId}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ICourseRateDetails>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ICourseRateDetails>;
      } else {
        throw error;
      }
    }
  };
})();